<!--
*****************************************************************************
*File : UserProfile.vue
*Module : Dashboard Frontend
*Purpose : Display all the resgistered users details.
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>

  <v-container
    id="userprofile"
    fluid
    tag="section"
    
  >

    <v-row>
      <v-col
        cols="12"
        lg="4"
        v-for="(item, i) in this.completeDetails"
        :key="i"
      >
      <base-material-card
          color="transparent"
          hover-reveal
      >
          <template v-slot:image>
            <v-card class="justify-center" color="teal" height="100%" v-if="item.active ==true">
              <v-card-title class="font-weight-bold white--text justify-center mt-n11">
              {{ item.username }}
              </v-card-title>
            </v-card>
            <v-card class="justify-center" color="grey" height="100%" v-else>
              <v-card-title class="font-weight-bold white--text justify-center mt-n11">
              {{ item.username }} {{"(Inactive)"}}
              </v-card-title>
            </v-card>
          </template>

          <template v-slot:reveal-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  v-bind="attrs"
                  class="mx-1"
                  color="teal"
                  light
                  icon
                  v-on="on"
                >
                  <v-icon class="teal--text" @click="toAdmin(item)">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>

              <span>Edit your profile</span>
            </v-tooltip>
          </template>

          <v-flex class="align-center">
          <v-img
            max-height="150"
            max-width="150"        
            :src="item.profile_image"            
          ></v-img>
          </v-flex>

          <v-card-title class="text--primary font-weight-light">
            Full name: {{ item.firstname }} {{ item.lastname }}
          </v-card-title>

          <v-card-title class="text--primary font-weight-light">
            Roles: {{ item.roles }}
          </v-card-title>              

        </base-material-card>

         
      </v-col>

     
    </v-row>
  </v-container>
</template>

<script>
import globalConf from '../../../globalConf'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import Api from '@/views/service/api'
import ApiResponse from './../service/api-response'

  export default {
    name: 'UserProfile',
    
    created () {
        
    },

    mounted() {
      Api().post('/api/admin/new_users').then((response) => {
        this.users = response.data;
        this.completeDetails = this.users.completeDetails;
        var roleInd = 0;
        for(roleInd = 0; roleInd < this.completeDetails.length; roleInd++) {
            var roleList = this.completeDetails[roleInd].roles.toString();
              this.completeDetails[roleInd].roles = roleList.replace(/['['\]]/g,'');
              if (this.completeDetails[roleInd].profile_image === "/media/null") {
                this.completeDetails[roleInd].profile_image = globalConf.defaultImagePath;
              } else {                
                this.completeDetails[roleInd].profile_image = globalConf.djangoBackend + this.completeDetails[roleInd].profile_image;
              }
        }
      })
      .catch(function (error) {
        ApiResponse.checkErrorCode(error.response.status);
      });

    },

    data() {
      return {
        completeDetails: [],
        imagePath: [],
        search: '',
        users: []
      }
    },

    computed: {

    },

    methods: {
      toAdmin(allInfo) {
        Api().post('/api/admin/new_users', {
        userID: allInfo.id
      }).then((response) => {
      })
      .catch(function (error) {
        ApiResponse.checkErrorCode(error.response.status);
      });
        this.$router.push({ name: 'User Update', params: { userID: allInfo, flag: true } })
      }
    }
  }
</script>

<style lang="scss">
.v-sheet {
  border-radius: 4px;
}
</style>
